import React, { useMemo } from 'react';
var AVAILABILITY;
(function (AVAILABILITY) {
  AVAILABILITY["IN_STOCK"] = "https://schema.org/InStock";
  AVAILABILITY["OUT_OF_STOCK"] = "https://schema.org/OutOfStock";
})(AVAILABILITY || (AVAILABILITY = {}));
export var SEOPrice = function SEOPrice(_ref) {
  var href = _ref.href,
    price = _ref.price,
    isAvailable = _ref.isAvailable;
  var isAvailableDevice = useMemo(function () {
    return isAvailable ? AVAILABILITY.IN_STOCK : AVAILABILITY.OUT_OF_STOCK;
  }, [isAvailable]);
  return /*#__PURE__*/React.createElement("div", {
    itemProp: "offers",
    itemScope: true,
    itemType: "https://schema.org/Offer"
  }, /*#__PURE__*/React.createElement("link", {
    href: href,
    itemProp: "url"
  }), /*#__PURE__*/React.createElement("meta", {
    content: isAvailableDevice,
    itemProp: "availability"
  }), /*#__PURE__*/React.createElement("meta", {
    content: "RUB",
    itemProp: "priceCurrency"
  }), /*#__PURE__*/React.createElement("meta", {
    content: "https://schema.org/NewCondition",
    itemProp: "itemCondition"
  }), /*#__PURE__*/React.createElement("meta", {
    content: price.toString(),
    itemProp: "price"
  }));
};